/* ==========================================================================================
   Commercial Equipment Online 2026 · ce-search-page.js · the search results page, after it has loaded
   (launch wave, key "search", 10-10-2026). sections/ce-main-search.liquid. No dependencies; deferred; idempotent.

   1. THE RESULT TABS ([data-ce-sx-tabs]): the tab you are on already shows Shopify's own count. Each other tab asks
      templates/search.ce-search-count.liquid for its number (/search?q=...&type=page&view=ce-search-count: a tiny
      JSON answer, one request per kind of result) and shows it; a tab with nothing in it leaves.
   2. SHOP THE CATEGORY ([data-ce-sx-cats]): Shopify's predictive search is asked for the store's collections whose
      names match the words, rendered by sections/ce-search-suggest.liquid (photo, name, LIVE count), and they are put
      in the results toolbar's own line (the line is there from the start, so nothing on the page moves).
   Anything that fails leaves the page as it was: the tabs still work as links.
   ========================================================================================== */
(() => {
  'use strict';
  if (window.CESearchPage) return;
  window.CESearchPage = true;

  // Shopify's search stops counting at 1,000 (the section says "1,000+" the same way)
  const num = (n) => {
    if (Number(n) >= 1000) return '1,000+';
    try { return Number(n).toLocaleString('en-AU'); } catch (e) { return String(n); }
  };

  const tabs = () => {
    const nav = document.querySelector('[data-ce-sx-tabs]');
    if (!nav) return;
    const q = nav.getAttribute('data-q') || '';
    if (!q) return;
    nav.querySelectorAll('[data-ce-sx-tab]').forEach((li) => {
      const key = li.getAttribute('data-ce-sx-tab');
      const out = li.querySelector('[data-ce-sx-n]');
      if (!out) return;
      if (out.textContent.trim() !== '') { li.classList.add('has-n'); return; }
      const params = new URLSearchParams();
      params.set('q', q);
      params.set('options[prefix]', 'last');
      if (key !== 'all') params.set('type', key);
      params.set('view', 'ce-search-count');
      fetch(`${(window.routes && window.routes.search_url) || '/search'}?${params.toString()}`, { credentials: 'same-origin' })
        .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
        .then((t) => {
          const data = JSON.parse(t.trim());
          const n = Number(data.n) || 0;
          if (n === 0 && !li.classList.contains('is-on') && key !== 'all') { li.hidden = true; return; }
          out.textContent = num(n);
          li.classList.add('has-n');
        })
        .catch(() => {});
    });
  };

  const cats = () => {
    const box = document.querySelector('[data-ce-sx-cats]');
    if (!box) return;
    const q = box.getAttribute('data-q') || '';
    if (!q) return;
    const params = new URLSearchParams();
    params.set('q', q);
    params.set('resources[type]', 'collection');
    params.set('resources[limit]', '6');
    params.set('section_id', 'ce-search-suggest');
    const base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    fetch(`${base}?${params.toString()}`, { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const list = doc.querySelector('.ce-sx__catlist');
        if (!list || !list.querySelector('li')) return;
        const label = document.createElement('span');
        label.className = 'ce-sx__cats-label';
        label.textContent = box.getAttribute('data-label') || '';
        box.replaceChildren(label, document.importNode(list, true));
        box.hidden = false;
        box.closest('.ce-sx__toolbar')?.classList.add('has-cats');
      })
      .catch(() => {});
  };

  const run = () => { tabs(); cats(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
})();
